import {
	Directive,
	Input,
	TemplateRef,
	ViewContainerRef,
	OnInit
} from '@angular/core';

import { ExperimentationService } from '@services/experimentation.service';

@Directive({
	standalone: false,
	selector: '[expEvaluate]'
})
export class ExperimentLayerDirective implements OnInit {
	private _layer = '';
	private _variation: string | string[] = '';
	private _experiment = '';
	private _isHidden = true;
	private _clientUpdatesSubscribed = false;

	 @Input() set expEvaluate(val: {layer?: string; variation: string | string[]; experiment?: string }){
		if (val){
			this._layer = val.layer || '';
			this._experiment = val.experiment || '';
			this._variation = val.variation;
			this._updateView();
		}
	}

	constructor(
		private readonly templateRef: TemplateRef<unknown>,
		private readonly viewContainer: ViewContainerRef,
		private readonly experimentationService: ExperimentationService
	) {
		this._subscribeToClientUpdates();
		this.experimentationService.clientReady$().subscribe(() => {
			this._subscribeToClientUpdates();
			this._updateView();
		});
	}

	ngOnInit(): void {
		if ((this._layer || this._experiment) && this._variation) {
			this._subscribeToClientUpdates();
			this._updateView();
		}
	}

	private _subscribeToClientUpdates(): void {
		const client = this.experimentationService.experimentationClient();
		if (!client || this._clientUpdatesSubscribed) {
			return;
		}

		client.$on('values_updated', () => {
			this._updateView();
		});
		this._clientUpdatesSubscribed = true;
	}

	private _updateView() {
		if (this._checkCondition()) {
			this._showContent();
		} else {
			this._hideContent();
		}
	}

	private _checkCondition(): boolean {
		const variations = Array.isArray(this._variation) ? this._variation : [this._variation];
		const layerValue = this._layer ? this.getExperimentLayer() : undefined;
		const experimentValue = this._experiment ? this.getExperiment() : undefined;

		for (const variation of variations) {
			if (variation === 'default') {
				if (!this.experimentationService.isClientReady()) {
					return true;
				}

				if (this._layer && (layerValue === undefined || layerValue === null)) {
					return true;
				}

				if (this._experiment) {
					const experiment = this.experimentationService.experimentationClient()?.getExperiment(this._experiment);
					if (experiment?.groupName === null) {
						return true;
					}
				}

				continue;
			}

			if (this._layer && layerValue === variation) {
				return true;
			}

			if (this._experiment && experimentValue === variation) {
				return true;
			}
		}

		return false;
	}

	private getExperimentLayer() {
		return this._layer
			&& this.experimentationService.getExperimentLayer(this._layer as string);
	}

	private getExperiment() {
		return this._experiment
			&& this.experimentationService.getExperiment(this._experiment as string);
	}

	private _hideContent(): void {
		this.viewContainer.clear();
		this._isHidden = true;
	}

	private _showContent(): void {
		if (this._isHidden) {
			this.viewContainer.createEmbeddedView(this.templateRef);
			this._isHidden = false;
		}
	}
}
